import {EntityData, field} from "@fedeltapointofsale/data-client";

export class LicenseData extends EntityData<LicenseData> {
     @field licenseId: number;
}
